import React, { useMemo } from "react";
import { Modal, StyleSheet, View } from "react-native";
import VStack from "../ui_atoms/VStack";
import IconButton from "./IconButton";
import { useTheme } from "../hooks/use-theme";
import Headline from "./Headline";

type InfoModalHeaderProps = {
    title: string;
    onClose: () => void;
};

const InfoModalHeader: React.FC<InfoModalHeaderProps> = ({ title, onClose }) => {
    const styles = useStyles();
    return (
        <View style={styles.headerContainer}>
            <Headline h="2" style={styles.headerTitle}>
                {title}
            </Headline>
            <IconButton style={styles.headerCloseButton} icon="close" size={28} onPress={onClose} />
        </View>
    );
};
type InfoModalProps = {
    visible: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title?: string;
};

const InfoModal: React.FC<InfoModalProps> = ({ children, onClose, visible, title }) => {
    const styles = useStyles();
    return visible ? (
        <Modal
            visible={true}
            onDismiss={onClose}
            presentationStyle={"pageSheet"}
            animationType="slide"
            statusBarTranslucent
            onRequestClose={onClose}
        >
            <VStack>
                <InfoModalHeader title={title || ""} onClose={onClose} />
                <View style={styles.childrenContainer}>{children}</View>
            </VStack>
        </Modal>
    ) : null;
};

const useStyles = () => {
    const { gridSize, marginSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                childrenContainer: {
                    flex: 0,
                    paddingHorizontal: marginSize,
                },
                headerContainer: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                },
                headerTitle: {
                    flexGrow: 1,
                    flexShrink: 1,
                    paddingLeft: marginSize,
                    paddingTop: gridSize / 2,
                },
                headerCloseButton: {
                    flexGrow: 0,
                    flexShrink: 0,
                    width: 48,
                    height: 48,
                    margin: 0,
                    marginLeft: gridSize / 2,
                },
            }),
        [gridSize, marginSize],
    );
};

export default InfoModal;
